import SkeletonText from './SkeletonText'

export default SkeletonText
